module.exports = __webpack_public_path__ + "img/maastopyorareitti_60px.56162bfd.png";